import { render } from "./NumberWidget.vue?vue&type=template&id=19e00689"
import script from "./NumberWidget.vue?vue&type=script&lang=js"
export * from "./NumberWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__